(() => {
  const sync = (scope = document) => {
    scope.querySelectorAll('[data-native-pack-availability]').forEach((source) => {
      const root = source.closest('[data-product-root]');
      const target = root?.querySelector('[data-product-json]');
      if (!target) return;
      try {
        const availability = JSON.parse(source.textContent);
        const product = JSON.parse(target.textContent);
        product.variants?.forEach((variant) => {
          const value = availability[String(variant.id)];
          if (typeof value === 'boolean') variant.available = value;
        });
        target.textContent = JSON.stringify(product);
      } catch (error) {
        console.error('Native pack availability:', error);
      }
    });
  };
  document.addEventListener('DOMContentLoaded', () => sync());
  document.addEventListener('shopify:section:load', (event) => sync(event.target));
})();
